import React, { memo } from "react";
import { useT } from "@al/next/al-ex";

import Iconfont from "~/components/ui/Iconfont";

import styles from "./styles.scss";

type Props = {
  title: string;
  rightClick?: () => void;
};

const SectionTitle: React.FC<Props> = (props) => {
  const t = useT();
  return (
    <div className={styles.title_box}>
      <span className={styles.title}>{props.title}</span>
      {props.rightClick ? (
        <span className={styles.more} onClick={props.rightClick}>
          {t("查看全部")}
          <Iconfont name="right" />
        </span>
      ) : null}
    </div>
  );
};

export default memo(SectionTitle);
